import { useEffect } from 'react';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { useErrorHandling } from '@/utils/errorHandling';
import { useAppDispatch } from '../hooks';
import { setLoader } from '@/lib/slices/globalLoaderSlice';

export const useHandleResponse = ({
    error,
    isSuccess,
    isPending = false,
    successAlertMessage = '',
    isSuccessCallBack = () => {}
}: {
    error: Error | null;
    isSuccess?: boolean;
    successAlertMessage?: string;
    isSuccessCallBack?: () => void;
    isPending?: boolean;
}) => {
    const { backendErrorHandler } = useErrorHandling();

    const { setAlert } = useNotificationsSnackbar();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setLoader(isPending));
    }, [isPending]);

    useEffect(() => {
        if (error) {
            backendErrorHandler()(error);
        }
    }, [error]);

    useEffect(() => {
        if (isSuccess) {
            if (successAlertMessage) {
                setAlert(successAlertMessage, 'success');
            }
            isSuccessCallBack?.();
        }
    }, [isSuccess, successAlertMessage]);
};
